import { formatDateMoment, setNumberWithPoint } from 'utils/utils'
import { Button } from 'avo-ui'
import icTrash from 'assets/images/ic-trash.svg'
import { Link } from 'react-router-dom'

export const TABLE_BEAUTY_PROFILE = {
    name: 'Beauty Profile',
    column: [
        {
            name: 'Title Beauty Personalize',
            key: 'name',
            render: ({ item }) => (
                <Link
                    to={`/general-setting/beauty-profile-list/update-beauty-profile?beautyProfileId=${item?.id}`}
                    className={'capitalize font-medium text-blue-90 hover:font-bold hover:underline'}
                >
                    {item?.name}
                </Link>
            ),
        },
        {
            name: 'Allow Multiple',
            key: 'is_allow_multiple',
            render: ({ value }) => <div>{value ? 'Ya' : 'Tidak'}</div>,
        },
        {
            name: 'Total User',
            key: 'total_users',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Updated At',
            key: 'updated_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <Button type={'outline'} title={'Delete'} icon={icTrash} onClick={() => onClickItem(item?.id)} />
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
}
